var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"payment-time","route":"/reports/billing-payment-time","file-name":"prazo-medio-de-recebimento.xlsx","period-label":"Período do pagamento","columns":_vm.columns,"default-days":360}})
}
var staticRenderFns = []

export { render, staticRenderFns }